import { Injectable, inject, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * The message of the last page load that failed (WAP-1857): a route resolver hands `set` to
 * the presenter as its inline target, the app shell renders the error state in place of the
 * routed page while the message holds, and the next navigation clears it.
 */
@Injectable({ providedIn: 'root' })
export class PageLoadErrorService {
  readonly message = signal<string | null>(null);

  readonly set = (message: string): void => {
    this.message.set(message);
  };

  constructor() {
    inject(Router)
      .events.pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntilDestroyed(),
      )
      .subscribe(() => this.message.set(null));
  }
}
